var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("订购数量统计分析"),
                      ]),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "200px" },
                        attrs: {
                          type: "daterange",
                          size: "small",
                          transfer: "",
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                        model: {
                          value: _vm.selectDates,
                          callback: function ($$v) {
                            _vm.selectDates = $$v
                          },
                          expression: "selectDates",
                        },
                      }),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px", "margin-left": "5px" },
                          attrs: {
                            size: "small",
                            placeholder: "选择苗场",
                            filterable: "",
                            clearable: "",
                          },
                          on: { "on-change": _vm.onSeedFarmChange },
                          model: {
                            value: _vm.selectedSeedFarmUuid,
                            callback: function ($$v) {
                              _vm.selectedSeedFarmUuid = $$v
                            },
                            expression: "selectedSeedFarmUuid",
                          },
                        },
                        _vm._l(_vm.seedFarmList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.seedFarmUuid,
                              attrs: { value: item.seedFarmUuid },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.seedFarmCode + " " + item.seedFarmName
                                )
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px", "margin-left": "5px" },
                          attrs: {
                            size: "small",
                            placeholder: "选择商品",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.selectedProductUuid,
                            callback: function ($$v) {
                              _vm.selectedProductUuid = $$v
                            },
                            expression: "selectedProductUuid",
                          },
                        },
                        _vm._l(_vm.productList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.productUuid,
                              attrs: { value: item.productUuid },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.productCode + "-" + item.productName
                                )
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "success",
                            size: "small",
                            icon: "ios-stats",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.beginStat()
                            },
                          },
                        },
                        [_vm._v("统计")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "right-bar" }),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    ref: "mainTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      size: "small",
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      height: _vm.mainTable.tableHeight,
                      stripe: "",
                      border: "",
                    },
                  }),
                  _c(
                    "Modal",
                    {
                      attrs: { width: 1000, "footer-hide": "" },
                      model: {
                        value: _vm.customerStatQuanityModal.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.customerStatQuanityModal, "show", $$v)
                        },
                        expression: "customerStatQuanityModal.show",
                      },
                    },
                    [
                      _vm.customerStatQuanityModal.innerSpin
                        ? _c("Spin", { attrs: { size: "large", fix: "" } })
                        : _vm._e(),
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "14px",
                            },
                          },
                          [_vm._v("订购数量统计")]
                        ),
                      ]),
                      _c("CustomerStatBar", {
                        ref: "customerStatBar",
                        staticStyle: { height: "400px", width: "100%" },
                        attrs: {
                          value: _vm.customerStatQuanityModal.barData,
                          text: _vm.customerStatQuanityModal.barTitle,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }